import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PARTNER_SCOPED,
  URL_PUBLIC,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/routing'

// Warehouse-less, partner + site scoped (mirrors cart-assistant): the site is chosen in-tool via
// the scope picker, so the URL carries `/sites/:storeConfigId` but no `/warehouses/:warehouse_id`.
// The parent route puts `storeConfigId` into the router match; the child route's scope wrapper reads
// it via useParams. Registered in the domain's `partnerScoped` router bucket.
const URL_SEO_SETTINGS = `${URL_PARTNER_SCOPED}/seo-settings${URL_SITE_SCOPED}`
const URL_SEO_SETTINGS_ROBOTS_TXT = `${URL_SEO_SETTINGS}/robots-txt`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'seo-settings'> | DashRouteType<'seo-settings-robots-txt'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'seo-settings': URL_SEO_SETTINGS,
  'seo-settings-robots-txt': URL_SEO_SETTINGS_ROBOTS_TXT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
